import { Action } from 'redux';

import {
  AuthorConfiguredViewSucceeded} from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { IProcessedViewMonitoringStatusInfo } from '../types/AuthorConfiguredDCRTypes';

export interface AuthorConfiguredViewSucceededAction extends Action {
  viewMonitoringStatusInfo: IProcessedViewMonitoringStatusInfo;
}

export function authorConfiguredViewSucceeded(viewMonitoringStatusInfo: IProcessedViewMonitoringStatusInfo): AuthorConfiguredViewSucceededAction {
  return {
    type: AuthorConfiguredViewSucceeded,
    viewMonitoringStatusInfo,
  };
}

export const isAuthorConfiguredViewSucceededAction = isActionFactory<AuthorConfiguredViewSucceededAction>(AuthorConfiguredViewSucceeded);
